"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'AreaSelectorMenuBranch',
    props: {
        branchId: {
            type: Number,
            required: true,
        },
        depth: {
            type: Number,
            required: true,
        },
        isLastBranch: {
            type: Boolean,
            default: false,
        },
        isLastArea: {
            type: Boolean,
            default: false,
        },
        employmentMap: {
            type: Object,
            required: true,
        },
        searchInput: {
            type: String,
            default: "",
        },
    },
    setup(__props) {
        const props = __props;
        const { selectBranch, isActive } = (0, vue_3.inject)('branchSelectorMenu', {
            selectBranch: (id) => { },
            isActive: (branch) => false,
        });
        const branch = (0, vue_3.computed)(() => {
            return props.employmentMap?.[props.branchId];
        });
        const searchMatchesSelf = (0, vue_3.computed)(() => {
            if (!props.searchInput || !branch.value) {
                return false;
            }
            return branch.value.name.toLowerCase().includes(props.searchInput);
        });
        const highlightClass = (0, vue_3.computed)(() => {
            return searchMatchesSelf.value ? 'highlight-matched' : '';
        });
        const rowClass = (0, vue_3.computed)(() => {
            return {
                'pl-2': props.depth > 0,
            };
        });
        function depthBarClass(d) {
            return {
                'depth-bar-inner': d > 1,
                'depth-bar-last': props.isLastBranch && (d === props.depth || props.isLastArea),
            };
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                class: (0, vue_2.normalizeClass)(["d-flex", highlightClass.value])
            }, [
                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(__props.depth, (d) => {
                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                        key: d,
                        class: (0, vue_2.normalizeClass)(["depth-bar", depthBarClass(d)])
                    }, null, 2 /* CLASS */));
                }), 128 /* KEYED_FRAGMENT */)),
                (branch.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                        key: 0,
                        class: (0, vue_2.normalizeClass)(["menu-area-row", rowClass.value])
                    }, [
                        (0, vue_2.createElementVNode)("div", {
                            class: (0, vue_2.normalizeClass)(["branch-name", { 'is-active': (0, vue_2.unref)(isActive)(branch.value) }])
                        }, [
                            (0, vue_2.createElementVNode)("a", {
                                class: "branch-link text-ellipsis",
                                onClick: _cache[0] || (_cache[0] = ($event) => { (0, vue_2.unref)(selectBranch)(branch.value?.id ?? -1); })
                            }, (0, vue_2.toDisplayString)(branch.value?.name ?? ""), 1 /* TEXT */)
                        ], 2 /* CLASS */)
                    ], 2 /* CLASS */))
                    : (0, vue_2.createCommentVNode)("v-if", true)
            ], 2 /* CLASS */));
        };
    }
});
